module.exports = __webpack_public_path__ + "static/media/3.6a755770.png";